import { BulletListContent } from './bullet-list-content.component.js';
export { BulletListContent } from './bullet-list-content.component.js';
import { BulletListIcon } from './bullet-list-icon.component.js';
export { BulletListIcon } from './bullet-list-icon.component.js';
import { BulletList } from './bullet-list.component.js';
export { BulletList } from './bullet-list.component.js';
import { ListItem } from './list-item.component.js';
export { ListItem } from './list-item.component.js';
import { List } from './list.component.js';
export { List } from './list.component.js';
import { OrderedList } from './ordered-list.component.js';
export { OrderedList } from './ordered-list.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
/* PLOP_COMPONENT_EXPORT_IN_INDEX */
// Please don't remove the above Plop token

/**
 * @deprecated Use <BulletList> instead
 */

var IconBulletList = deprecatedComponent({
  displayName: 'IconBulletList',
  root: BulletList,
  description: 'Use BulletList instead'
});
/**
 * @deprecated Use <BulletListIcon> instead
 */

var IconBulletListIcon = deprecatedComponent({
  displayName: 'IconBulletListIcon',
  root: BulletListIcon,
  description: 'Use BulletListIcon instead'
});
/**
 * @deprecated Use <BulletListContent> instead
 */

var IconBulletListItem = deprecatedComponent({
  displayName: 'IconBulletListItem',
  root: BulletListContent,
  description: 'Use BulletListContent instead'
});
var Ul = List;
var Ol = OrderedList;
var Li = ListItem;
export { IconBulletList, IconBulletListIcon, IconBulletListItem, Li, Ol, Ul };